import _typeof from "@babel/runtime/helpers/typeof";
import { SLIDES_PER_VIEW_DEFAULT_VALUE } from "../constants";
export var getSlidesPerView = function getSlidesPerView(slider) {
  if (_typeof(slider === null || slider === void 0 ? void 0 : slider.slides) === 'object') {
    var _slider$slides, _slider$slides2;
    var value = typeof ((_slider$slides = slider.slides) === null || _slider$slides === void 0 ? void 0 : _slider$slides.perView) === 'function' ? slider.slides.perView() : (_slider$slides2 = slider.slides) === null || _slider$slides2 === void 0 ? void 0 : _slider$slides2.perView;
    return typeof value === 'number' ? value : SLIDES_PER_VIEW_DEFAULT_VALUE;
  }
  return SLIDES_PER_VIEW_DEFAULT_VALUE;
};
//# sourceMappingURL=getSlidesPerView.js.map